

// 正式

const VUE_APP_WS_URL = 'wss://api.fogold.com/websocket';
const VUE_APP_BASEURL = 'https://api.fogold.com';
// 测试
// const VUE_APP_WS_URL = 'ws://192.168.1.2:8080/websocket';//测试
// const VUE_APP_BASEURL = 'http://192.168.1.2:8080';//测试

export { VUE_APP_WS_URL, VUE_APP_BASEURL };